import {AsyncValidatorFn, FormControl} from '@angular/forms';
import {ContactDBService} from '../@db/contact-db.service';
import {HttpErrorResponse} from '@angular/common/http';
import {get400OrComplain} from '../@utils/pop-then-str';
import {Observable} from 'rxjs/Observable';
import {ValidationErrors} from '@angular/forms/src/directives/validators';

export namespace Contact {
  export interface Model {
    active: boolean;
    created: Date;
    lead: number;
    format_type: FormatType;
    is_primary: boolean;
    mobile: string;
    landline: string;
    email: string;
    block: boolean;
    vars: { [key: string]: any };
  }

  export namespace Format {
    export interface Mobile extends Model {
      format_type: FormatType.mobile;
      mobile: string;
      landline: null;
      email: null;
    }

    export interface Landline extends Model {
      format_type: FormatType.landline;
      mobile: null;
      landline: string;
      email: null;
    }

    export interface Email extends Model {
      format_type: FormatType.email;
      mobile: null;
      landline: null;
      email: string;
    }
  }

  export namespace Validation {
    export namespace Input {
      export interface Mobile {
        number: string;
      }

      export interface Landline {
        number: string;
      }

      export interface Email {
        address: string;
      }
    }
    export namespace Output {
      export interface Mobile {
        number: string;
      }

      export interface Landline {
        number: string;
      }

      export interface Email {
        address: string;
      }
    }
    export namespace Error {
      export interface Mobile {
        number: string[];
      }

      export interface Landline {
        number: string[];
      }

      export interface Email {
        address: string[];
      }
    }

    export const forMobile = validatorFactory('validateMobile', 'number');
    export const forLandline = validatorFactory('validateLandline', 'number');
    export const forEmail = validatorFactory('validateEmail', 'address');

    function validatorFactory(serviceMethod, formatField) {
      return (contactDB: ContactDBService): AsyncValidatorFn => {
        return (control: FormControl): Observable<ValidationErrors | null> =>
          Observable.of(control.value).flatMap(value => {
            if (value) {
              return contactDB[serviceMethod](control.value).map(() => null)
                .catch((error: HttpErrorResponse) => Observable.of({invalid: get400OrComplain(error)[formatField]}));
            } else {
              return Observable.of(null);
            }
          });
      };
    }
  }

  export enum FormatType {
    mobile = 'mobile',
    landline = 'landline',
    email = 'email',
  }
}
